<template>
  <!-- tripWaypoint Form -->

  <div class="relative">
    <fieldset class="fieldset mb-3">
      <legend class="fieldset-legend">Adresas*</legend>
      <div class="flex items-center gap-2">
        <label class="input flex items-center grow gap-2">
          <input
            type="text"
            v-model="form.address"
            @input="searchAddress(form.address)"
            class="grow"
            placeholder="Ieškokite adreso"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            class="h-4 w-4 opacity-70"
          >
            <path
              fill-rule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clip-rule="evenodd"
            />
          </svg>
        </label>
        <button
          @click="addTripWaypoint"
          class="btn btn-primary shrink-0"
          :disabled="!(form.address && form.lng && form.lat)"
        >
          Įtraukti
        </button>
      </div>
    </fieldset>

    <ul
      v-if="suggestions.length"
      class="dropdown rounded-md w-3/4 absolute top-full left-0 bg-base-100 shadow-lg z-10"
    >
      <li
        v-for="(suggestion, index) in suggestions"
        :key="index"
        @click="handleSearchAddressSelect(suggestion)"
        class="dropdown-item cursor-pointer flex items-center justify-between gap-2"
      >
        <span
          >{{ suggestion.name }}<template v-if="suggestion.municipality">
            ({{ suggestion.municipality }})</template
          ></span
        >
        <span
          v-if="suggestion.source === 'internal'"
          class="badge badge-sm badge-primary shrink-0"
          >Jūsų adresas</span
        >
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, defineEmits } from "vue";
import { useAddressSearch } from "@/composables/search/useAddressSearch";
import { useRestrictionCheck } from "@/composables/gis/useRestrictionCheck";

// Emits to parent
const emit = defineEmits(["updateTripWaypoints", "updateRouteInfo"]);

// Reactive form state
const form = ref({
  trip_id: 9999,
  address: null,
  lng: null,
  lat: null,
  isInRestriction: false,
  time: "",
  type: "planning",
});

const tripWaypoints = ref([]);

/*
  Address search
*/
const { suggestions, searchAddress, selectAddress } = useAddressSearch();
const { checkRestriction } = useRestrictionCheck();

const handleSearchAddressSelect = async (suggestion) => {
  const selected = selectAddress(suggestion);
  form.value.address = selected.address;
  form.value.lng = selected.lng;
  form.value.lat = selected.lat;
  form.value.isInRestriction = await checkRestriction(
    selected.lng,
    selected.lat,
  );
  form.value.time = "";
};

/*
  Construct waypoints
*/

// Add tripWaypoint to the list
const addTripWaypoint = () => {
  if (form.value.address && form.value.lng && form.value.lat) {
    tripWaypoints.value.push({ ...form.value });

    emitTripInfo();
    resetForm();
  } else {
    alert("Pasirinkite adresą iš paieškos rezultatų sąrašo.");
  }
};

// Emit tripWaypoint list to the parent automatically
const emitTripInfo = () => {
  emit("updateTripWaypoints", tripWaypoints.value);
};

// Reset form fields
const resetForm = () => {
  form.value = {
    trip_id: 9999,
    address: null,
    lng: null,
    lat: null,
    isInRestriction: false,
    time: "",
    type: "planning",
  };
  tripWaypoints.value = [];
};
</script>

<style scoped>
.dropdown {
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-item {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background-color: #f9f9f9;
}
</style>
